export function trackMetaLead() {
  if (window?.fbq != null) {
    window.fbq("track", "Lead");
  }
}
